import { Rule } from '@webkit/validation';

export function minLength<T extends string | any[] | null>(min: number, error?: string) {
    return {
        id: 'min-length',
        validator: value => {
            if (!value) return true;
            return value.length >= min;
        },
        error: value => {
            if (error) return error;

            if (typeof value === 'string') {
                return `Must be at least ${min} characters (${value.length} entered)`;
            }

            if (Array.isArray(value)) {
                return `Select at least ${min} (${value.length} selected)`;
            }

            return `Must be at least ${min}`;
        },
    } as Rule<T>;
}
